import "./Locks.css";

import { Navigate } from "react-router-dom";

export const IdentityUnavailableText = "Identity is unavailable, try again in a few minutes.";

/** Ark.Core answered 503 identity-unavailable: it cannot tell what the caller may read, so it shows nothing rather than guess. */
export function IdentityUnavailableState(props: { onRetry?: () => void; compact?: boolean }) {
    return (
        <div className={`identity-unavailable-state${props.compact ? " compact" : ""}`} role="alert">
            <div className="identity-unavailable-text">{IdentityUnavailableText}</div>
            {props.onRetry ? (
                <button type="button" className="lock-link-button" onClick={props.onRetry}>Try again</button>
            ) : null}
        </div>
    );
}

/** The manifest is `partial`: lock grants were unknown, so locked subtrees are missing from the listing. */
export function PartialLocksBanner(props: { partial: boolean }) {
    if (!props.partial) return null;
    return (
        <div className="partial-locks-banner" role="status">
            Some locked pages are not shown while Identity is unavailable
        </div>
    );
}

export type LoadError = "not-found" | "identity-unavailable" | undefined;

/**
 * What a failed page or tree load shows: a hidden page and a page that does not exist are the same 404, and both go to the app's
 * not-found view (Ark never says a page is forbidden); Identity being unavailable gets its own retry state.
 */
export function LoadGate(props: { error: LoadError; onRetry?: () => void; children: React.ReactNode }) {
    if (props.error === "not-found") return <Navigate to="/notfound" replace />;
    if (props.error === "identity-unavailable") return <IdentityUnavailableState onRetry={props.onRetry} />;
    return <>{props.children}</>;
}
